import { FetchItOutput } from "./fetchIt";

export function fetchItCatch(): FetchItOutput {
  const blobParts = [JSON.stringify(null)];
  const blob = new Blob(blobParts, { type: "application/json" });
  const init: ResponseInit = {
    status: 418,
    statusText: "custom app offline status",
  };
  return {
    tag: "client-error" as const,
    response: new Response(blob, init),
  };
}
